import { Session } from '@ais-ui/auth';

export type DetectedEvent = {
  ack_state: number;
  ack_state_modified_by: string;
  ack_state_modified_ts: Date | null;
  actText: string;
  act_lat: number;
  act_lon: number;
  act_ts: Date;
  activated: Date;
  callSign: string;
  deact_lat: number;
  deact_lon: number;
  deact_ts: Date | null;
  deactivated: Date | null;
  id: string;
  imo: string;
  lost: boolean;
  mac_address: string;
  mmsi: number;
  name: string;
  severity: string;
  shapeUid: string;
  shipName: string;
  type: string;
  subtype: string;
  type_of_mobile: string;
};

export type EventsResponse = {
  endDateTime: number;
  endTime: string;
  events: DetectedEvent[];
  startDateTime: number;
  startTime: string;
};

export const getCurrentEvents = async (
  session: Session
): Promise<EventsResponse> => {
  const response = await session.request('getCurrentEvents', {
    forceReload: true,
  });

  return response;
};

export const getEventsForPeriod = async (
  session: Session,
  startDateTime: Date,
  endDateTime: Date
): Promise<EventsResponse> => {
  const response = await session.request('getHistoricalEvents', {
    startTime: startDateTime.toISOString(),
    endTime: endDateTime.toISOString(),
  });

  return response;
};

export const checkForNewEvents = async (session: Session) => {
  const response = await session.request('checkForNewEvents', {});

  return response;
};
